import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function IdPhotoPrivacyPolicyZhTw() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 隱私政策

"證件照應用-證件照製作"（以下簡稱"本應用"）尊重用戶的隱私，致力於保護個人資訊。本應用不收集用戶的個人資訊，並採取措施保護用戶資料。本隱私政策（以下簡稱"本政策"）規定了本應用中資訊的處理方式。

## 第1條（個人資訊收集與管理方針）

本應用不收集用戶的任何個人資訊（如姓名、地址、電話號碼等）。應用內的所有功能都基於不收集個人資訊的前提設計。此外，為保護用戶隱私，我們不收集或儲存任何可識別個人身份的資訊。

## 第2條（用戶資料儲存）

在本應用中，用戶掃描的所有結果僅儲存在用戶裝置中，不會保存到外部伺服器。因此，本應用及其開發者無法訪問用戶掃描的資料。我們保證這些資料不會提供給第三方，並將安全地儲存在用戶裝置中。

## 第3條（廣告投放）

本應用通過Google AdMob投放廣告。在廣告投放過程中，Google提供的系統可能會自動收集用於廣告優化的資料，但這些資料按照Google的隱私政策進行管理。本應用不保留任何與廣告投放相關的個人資訊。詳情請參閱Google的隱私政策。

## 第4條（用戶權利與資料管理）

本應用確保用戶可以完全控制自己的資料。用戶可以隨時刪除應用內的資料，本應用在未經用戶操作的情況下不會向外部傳輸資料。此外，根據使用條款，由於使用本應用時不使用個人資訊，因此不適用於資訊公開、更正、刪除或停止使用的請求。

## 第5條（隱私政策的變更）

本應用可能會定期審查本政策內容，並根據法律修訂或應用功能變更等情況對本政策進行修改，以提高用戶隱私保護。發生變更時，我們將通過在本應用內發布最新的隱私政策通知用戶，該政策將在發布後立即生效。請用戶定期查看本政策。

## 第6條（聯絡方式）

如對本政策有任何疑問或諮詢，請通過以下方式聯絡我們：

電子郵箱：linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default IdPhotoPrivacyPolicyZhTw; 
